// extracted by mini-css-extract-plugin
module.exports = {"icon_size":"CourseAchive_icon_size__0ZfjN","animSize":"CourseAchive_animSize__Pgf5j"};